export const gestionNews =
  "https://gestion.pe/tecnologia/whatsapp-business-el-alido-de-las-pymes-peruanas-para-incrementar-sus-ventas-online-noticia/";

export const pqsNews =
  "https://pqs.pe/tu-negocio/negocios-estrategias-para-optimizar-las-ventas-por-whatsapp-business/";

export const caretasNews =
  "https://caretas.pe/estilo-de-vida/cinco-estrategias-para-optimizar-las-ventas-por-whatsapp-business/";

export const andinaNews =
  "https://andina.pe/agencia/noticia-whatsapp-business-cinco-estrategias-para-optimizar-las-ventas-858518.aspx";

export const whatsappTramy =
  "https://api.whatsapp.com/send?phone=51902462575&text=Hola,%20estoy%20interesado%20en%20Tramy.io.%20Deseo%20m%C3%A1s%20informaci%C3%B3n";
export const blogTramy = "https://tramy.substack.com/";

export const calendlyTramy =
  "https://calendly.com/demotramy/demo?month=2021-10";

export const post1Tramy =
  "https://tramy.substack.com/p/comercio-conversacional";

export const post2Tramy = "https://tramy.substack.com/p/intregar-api-whatsapp";

export const post3Tramy = "https://tramy.substack.com/p/tramy";

export const whatsappApi =
  "https://developers.facebook.com/docs/whatsapp/pricing/conversationpricing";

export const video1Tramy = "https://www.youtube.com/embed/_llzQVg9_Gs";

export const video2Tramy = "https://www.youtube.com/embed/8ob5W7wTYAA";

export const video3Tramy = "https://www.youtube.com/embed/fOZ4atCiDsk";

export const video4Tramy = "https://www.youtube.com/embed/XuxeMprr6EM";

export const tramyPodcast =
  "https://open.spotify.com/embed/show/2Q2V7EO2NM8RK9oLykq4Ni?utm_source=generator";
